module.exports = __webpack_public_path__ + "static/media/nn-Nonord-C-trial-Kap.8df05a1a.mp3";